import Image from 'next/image';
import NextLink from 'next/link';

import {sprinkles} from '#style/sprinkles';

import {Button, Text} from '../../base';

import {InfoCtaProps} from './InfoCTA.types';

import * as css from './InfoCTA.css';

export const InfoCTA = ({title, paragraph, buttonText, href, imageUrl}: InfoCtaProps) => (
  <div className={sprinkles({layout: 'grid'})}>
    <div className={css.mainImage}>
      <Image aria-hidden alt="" src={imageUrl} layout="fill" objectFit="cover" />
    </div>

    <div
      className={sprinkles({
        colSpan: [4, 6, 5],
        colStart: [1, 2, 7],
        dir: 'col',
        flex: 'flex',
        content: ['start', 'start', 'center'],
        gap: [40, 48],
      })}>
      <Text as="h3" color="deepBurgundy" variant="heading2">
        {title}
      </Text>

      <Text as="p" color="mineShaft" variant="body">
        {paragraph}
      </Text>

      <NextLink href={href} passHref>
        <Button as="a" className={sprinkles({w: ['full', 'full', 'maxContent']})} icon="ArrowRight">
          {buttonText}
        </Button>
      </NextLink>
    </div>
  </div>
);
